export const channelKeys = {
    all: ['channels'],
    list: (params) => ['channels', 'list', params],
};
